import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
	streams: [],
	stream: null,
	search: [],

	creating: false,
	deleting: false,
	updating: false,
	restoring: false,
	gettingList: false,
	gettingItem: false,
	searching: false,
	importing: false,

	isError: false,
	errorCode: 0,
	errorMessage: null,
};

export const TeamSlice = createSlice({
	name: 'team',
	initialState,
	reducers: {

		clearTeamList: (state, action) => {
			return { ...state, teams: [] };
		},

		clearTeamItem: (state, action) => {
			return { ...state, team: null };
		},

		clearTeamSearchResult: (state, action) => {
			return { ...state, search: [] };
		},

		onLoadCreate: (state, action ) => {
			return {...state, creating: true};
		},

		onLoadDelete: (state, action ) => {
			return {...state, deleting: true};
		},

		onLoadRestore: (state, action ) => {
			return {...state, restoring: true};
		},

		onLoadArchive: (state, action ) => {
			return {...state, deleting: true};
		},

		onLoadUpdate: (state, action ) => {
			return {...state, updating: true};
		},

		onLoadUpdateStatuses: (state, action ) => {
			return {...state, updating: true};
		},

		onLoadList: (state, action ) => {
			return {...state, gettingList: true};
		},

		onLoadItem: (state, action ) => {
			return {...state, gettingItem: true};
		},

		onLoadSearch: (state, action ) => {
			return {...state, search: [], searching: true};
		},

		onLoadImport: (state, action ) => {
			return {...state, importing: true};
		},

		// Success
		onSuccessCreate: (state, action) => {
			return {...state, creating: false};
		},

		onSuccessDelete: (state, action) => {
			return {...state, deleting: false};
		},

		onSuccessRestore: (state, action) => {
			return {...state, restoring: false};
		},

		onSuccessUpdate: (state, action) => {
			return {...state, updating: false};
		},

		onSuccessUpdateStatuses: (state, action) => {
			return {...state, updating: false};
		},

		onSuccessList: (state, action) => {
			return {...state, teams: action.payload.data, gettingList: false};
		},

		onSuccessItem: (state, action) => {
			return {...state, team: action.payload.data, gettingItem: false};
		},

		onSuccessSearch: (state, action) => {
			return {...state, search: action.payload.data, searching: false};
		},

		onSuccessImport: (state, action) => {
			return {...state, importing: false};
		},

		// Errors
		onFailCreate: (state, action) => {
			return {...state, creating: false };
		},
		onFailDelete: (state, action) => {
			return {...state, deleting: false };
		},
		onFailRestore: (state, action) => {
			return {...state, restoring: false };
		},
		onFailUpdate: (state, action) => {
			return {...state, updating: false };
		},
		onFailUpdateStatuses: (state, action) => {
			return {...state, updating: false };
		},
		onFailList: (state, action) => {
			return {...state, teams: [] };
		},
		onFailItem: (state, action) => {
			return {...state, team: null };
		},
		onFailSearch: (state, action) => {
			return { ...state, search: [], searching: false };
		},
		onFailImport: (state, action) => {
			return { ...state, importing: false };
		},
	},
});

export const {
	clearTeamItem,
	clearTeamList,
	clearTeamSearchResult
} = TeamSlice.actions;
